// 定义工具类型常量
export const TOOLS = {
  SELECT: 'select',
  RECTANGLE: 'rectangle',
  CIRCLE: 'circle',
  LINE: 'line',
  ARROW: 'arrow',
  TEXT: 'text',
  FREEHAND: 'freehand',
  CLOUD: 'cloud',
}

// 默认颜色
export const DEFAULT_COLORS = {
  STROKE: '#ff0000',
  FILL: 'transparent',
  TEXT: '#ff0000',
}

// 线条粗细
export const STROKE_WIDTHS = [1, 2, 4, 6, 8]

// 颜色选项
export const STROKE_COLORS = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#000000', '#ffffff']
